import React from 'react';
import { Card, CardContent, Grid, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	h4: {
        marginLeft: 15
	}
}));

interface ArticleFieldProps {
    label?: string,
    children: React.ReactNode,
    container?: React.FunctionComponent<{children: React.ReactNode}> 
};

const ArticleField = (props: ArticleFieldProps) => {
    const classes = useStyles();

    return <Grid item xs={12}>
        {React.createElement((props.container ?? Card), {
            children: <>
                {props.label && <h4 className={classes.h4}>{props.label}:</h4>}
                <CardContent>
                    {props.children}
                </CardContent>
            </>
        })}
    </Grid>
}

export default ArticleField;